<div
  class="flex flex-col min-h-[300px] justify-center items-stretch"
  testId="item-attributes-container"
>
  <ng-container [ngSwitch]="view$ | async">
    <ng-container *ngSwitchCase="'list'">
      <app-attribute-list></app-attribute-list>
    </ng-container>
    <ng-container *ngSwitchCase="'create'">
      <app-add-attribute></app-add-attribute>
    </ng-container>
    <ng-container *ngSwitchCase="'addValue'">
      <app-update-attribute-value></app-update-attribute-value>
    </ng-container>
    <ng-container *ngSwitchCase="'edit'">
      <app-edit-attribute></app-edit-attribute>
    </ng-container>
  </ng-container>
</div>
